import {
  GET_API_TOKEN,
  GET_API_TOKEN_ERROR,
  GET_API_TOKEN_SUCCESS,
  ADD_API_TOKEN,
  ADD_API_TOKEN_ERROR,
  ADD_API_TOKEN_SUCCESS,
  MODIFY_API_TOKEN,
  MODIFY_API_TOKEN_ERROR,
  MODIFY_API_TOKEN_SUCCESS,
  DELETE_API_TOKEN,
  DELETE_API_TOKEN_ERROR,
  DELETE_API_TOKEN_SUCCESS,
  MODIFY_SYNDI_CLICK_SETTINGS,
  MODIFY_SYNDI_CLICK_SETTINGS_SUCCESS,
  MODIFY_SYNDI_CLICK_SETTINGS_ERROR,
  GET_SYNDI_CLICK_SETTINGS,
  GET_SYNDI_CLICK_SETTINGS_SUCCESS,
  GET_SYNDI_CLICK_SETTINGS_ERROR,
  GET_SYNDI_CLICK_ADMIN_SETTINGS,
  GET_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS,
  GET_SYNDI_CLICK_ADMIN_SETTINGS_ERROR,
  MODIFY_SYNDI_CLICK_ADMIN_SETTINGS,
  MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS,
  MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_ERROR,
  GET_SYNDI_CLICK_SOURCE_TYPES,
  GET_SYNDI_CLICK_SOURCE_TYPES_SUCCESS,
  GET_SYNDI_CLICK_SOURCE_TYPES_ERROR,
  CREATE_SYNDI_CLICK_SOURCE_TYPE,
  CREATE_SYNDI_CLICK_SOURCE_TYPE_SUCCESS,
  CREATE_SYNDI_CLICK_SOURCE_TYPE_ERROR,
} from "./actionTypes"

const initialState = {
  api_tokens: [],
  error: null,
  loading: false,
  syndi_click_settings: [],
  syndi_click_settings_error: null,
  syndi_click_admin_setting: [],
  syndi_click_admin_setting_error: null,
  syndi_click_admin_setting_loading: false,
  syndi_click_source_types: [],
  syndi_click_source_types_error: null,
  syndi_click_source_types_loading: false,
}

const ApiTokens = (state = initialState, action) => {
  switch (action.type) {
    case GET_API_TOKEN:
      return {
        ...state,
        loading: true
      }

    case GET_API_TOKEN_SUCCESS:
      return {
        ...state,
        api_tokens: action.payload,
        loading: false
      }

    case GET_API_TOKEN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case MODIFY_API_TOKEN:
      return {
        ...state,
        error: null,
        loading: true
      }

    case MODIFY_API_TOKEN_SUCCESS:
      return {
        ...state,
        api_tokens: state.api_tokens.map(ccp => ccp._id == action.payload.token._id
          ? { ccp, ...action.payload.token }
          : ccp,
        ),
        error: null,
        loading: false
      }

    case MODIFY_API_TOKEN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case ADD_API_TOKEN:
      return {
        ...state,
        error: null,
        loading: true
      }

    case ADD_API_TOKEN_SUCCESS:
      return {
        ...state,
        api_tokens: [...state.api_tokens, action.payload.token],
        error: null,
        loading: false
      }

    case ADD_API_TOKEN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case DELETE_API_TOKEN:
      return {
        ...state,
        error: null,
        loading: true
      }

    case DELETE_API_TOKEN_SUCCESS:
      return {
        ...state,
        api_tokens: state.api_tokens.filter(e => e._id !== action.payload._id),
        error: null,
        loading: false
      }

    case DELETE_API_TOKEN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      }

    case GET_SYNDI_CLICK_SETTINGS:
      return {
        ...state,
        loading: true
      }

    case GET_SYNDI_CLICK_SETTINGS_SUCCESS:
      return {
        ...state,
        syndi_click_settings: action.payload,
        loading: false
      }

    case GET_SYNDI_CLICK_SETTINGS_ERROR:
      return {
        ...state,
        syndi_click_settings_error: action.payload,
        loading: false
      }

    case MODIFY_SYNDI_CLICK_SETTINGS:
      return {
        ...state,
        syndi_click_settings_error: null,
        loading: true
      }

    case MODIFY_SYNDI_CLICK_SETTINGS_SUCCESS:
      return {
        ...state,
        syndi_click_settings: action.payload,
        syndi_click_settings_error: null,
        loading: false
      }

    case MODIFY_SYNDI_CLICK_SETTINGS_ERROR:
      return {
        ...state,
        syndi_click_settings_error: action.payload,
        loading: false
      }
    case GET_SYNDI_CLICK_ADMIN_SETTINGS:
      return {
        ...state,
        syndi_click_admin_setting_loading: true
      }

    case GET_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS:
      return {
        ...state,
        syndi_click_admin_setting: action.payload,
        syndi_click_admin_setting_loading: false
      }

    case GET_SYNDI_CLICK_ADMIN_SETTINGS_ERROR:
      return {
        ...state,
        syndi_click_admin_setting_error: action.payload,
        syndi_click_admin_setting_loading: false
      }

    case MODIFY_SYNDI_CLICK_ADMIN_SETTINGS:
      return {
        ...state,
        syndi_click_admin_setting_error: null,
        syndi_click_admin_setting_loading: true
      }

    case MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_SUCCESS:
      return {
        ...state,
        syndi_click_admin_setting: action.payload,
        syndi_click_admin_setting_error: null,
        syndi_click_admin_setting_loading: false
      }

    case MODIFY_SYNDI_CLICK_ADMIN_SETTINGS_ERROR:
      return {
        ...state,
        syndi_click_admin_setting_error: action.payload,
        syndi_click_admin_setting_loading: false
      }

    case GET_SYNDI_CLICK_SOURCE_TYPES:
      return {
        ...state,
        syndi_click_source_types_loading: true
      }

    case GET_SYNDI_CLICK_SOURCE_TYPES_SUCCESS:
      return {
        ...state,
        syndi_click_source_types: action.payload,
        syndi_click_source_types_loading: false
      }

    case GET_SYNDI_CLICK_SOURCE_TYPES_ERROR:
      return {
        ...state,
        syndi_click_source_types_error: action.payload,
        syndi_click_source_types_loading: false
      }

    case CREATE_SYNDI_CLICK_SOURCE_TYPE:
      return {
        ...state,
        syndi_click_source_types_loading: true
      }

    case CREATE_SYNDI_CLICK_SOURCE_TYPE_SUCCESS:
      return {
        ...state,
        syndi_click_source_types: [...state.syndi_click_source_types, action.payload],
        syndi_click_source_types_loading: false
      }

    case CREATE_SYNDI_CLICK_SOURCE_TYPE_ERROR:
      return {
        ...state,
        syndi_click_source_types_error: action.payload,
        syndi_click_source_types_loading: false
      }

    default:
      return state
  }
}

export default ApiTokens
